import { createSelector } from 'reselect';

const selectAthleteState = (state) => state.athlete;

export const getAthletes = createSelector([selectAthleteState], (state) => state.athletes);
export const getCurrentAthlete = createSelector([selectAthleteState], (state) => state.selectedAthlete);
